// eApp_VideoPage.js
import React, { useState } from 'react';
import { ChevronDown, Video } from 'lucide-react';
import Modal from './eApp_Modal';
import EditableText from './eApp_EditableText';

const VideoPage = ({ video, onBack, onEdit }) => {
  const [isUrlModalOpen, setIsUrlModalOpen] = useState(false);
  const [tempUrl, setTempUrl] = useState(video.url);
  const [tempThumbnail, setTempThumbnail] = useState(video.thumbnail);

  const handleUrlSubmit = () => {
    if (!tempUrl.startsWith("http")) {
      alert("Please enter a valid URL.");
      return;
    }
    const updatedVideo = { ...video, url: tempUrl, thumbnail: tempThumbnail };
    onEdit(updatedVideo);
    setIsUrlModalOpen(false);
  };

  return (
    <div className="p-4 bg-[#FAFAFA] animate-fadeIn max-w-7xl mx-auto">
      <button onClick={onBack} className="mb-4 flex items-center text-[#333333] hover:text-[#666666] transition-colors">
        <ChevronDown size={18} className="mr-2 transform rotate-90" />
        Back to Category
      </button>
      <div className="aspect-video bg-[#F0EAE2] rounded-lg flex items-center justify-center mb-4 overflow-hidden max-w-7xl mx-auto">
        {video.url ? (
          <div className="w-full h-full relative">
            <iframe
              width="100%"
              height="100%"
              src={video.url}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              sandbox="allow-same-origin allow-scripts"
              style={{ pointerEvents: 'none' }}
            ></iframe>
            <div
              className="absolute inset-0"
              onClick={() => setIsUrlModalOpen(true)}
              style={{ cursor: 'pointer' }}
            ></div>
          </div>
        ) : (
          <div className="w-full h-full flex items-center justify-center cursor-pointer" onClick={() => setIsUrlModalOpen(true)}>
            <Video className="text-white" size={72} />
            <p className="ml-2 text-white">Click to add Video URL</p>
          </div>
        )}
      </div>
      <div className="max-w-2xl mx-auto">
        <EditableText value={video.title} onChange={(newTitle) => onEdit({ ...video, title: newTitle })} />
        <EditableText value={video.description} onChange={(newDescription) => onEdit({ ...video, description: newDescription })} multiline />
      </div>
      
      <Modal isOpen={isUrlModalOpen} onClose={() => setIsUrlModalOpen(false)}>
        <h2 className="text-xl font-bold mb-4">Add Video and Thumbnail URL</h2>
        <input
          type="text"
          value={tempUrl}
          onChange={(e) => setTempUrl(e.target.value)}
          placeholder="Enter Video URL"
          className="w-full p-2 border border-[#E0E0E0] rounded mb-4"
        />
        <input
          type="text"
          value={tempThumbnail}
          onChange={(e) => setTempThumbnail(e.target.value)}
          placeholder="Enter Thumbnail URL"
          className="w-full p-2 border border-[#E0E0E0] rounded mb-4"
        />
        <button
          onClick={handleUrlSubmit}
          className="bg-[#F0EAE2] text-[#333333] py-2 px-4 rounded hover:bg-[#E0E0E0]"
        >
          Submit
        </button>
      </Modal>
    </div>
  );
};

export default VideoPage;
